import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVerticalBarsStacked100 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M6.583 25.226h4.74v-5.419h-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M6.583 13.418h4.74V3.771c0-.748-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.607-1.355 1.355z"
      clipRule="evenodd"
    />
    <path
      fill="#98B9FA"
      fillRule="evenodd"
      d="M6.583 19.807h4.74v-7h-4.74zm7.451-3.389h4.74v-6h-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M14.034 25.226h4.74v-9.482h-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M14.034 10.418h4.74V3.772c0-.748-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.607-1.355 1.355z"
      clipRule="evenodd"
    />
    <path
      fill="#98B9FA"
      fillRule="evenodd"
      d="M21.485 17.418h4.74v-8h-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M21.485 25.226h4.741v-8.128h-4.741z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M21.485 9.417h4.74V3.772c0-.748-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.607-1.355 1.355z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVerticalBarsStacked100;
